module.exports = __webpack_public_path__ + "img/img3.386301cd.png";